var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uc-rich-text-display",domProps:{"innerHTML":_vm._s(_vm.richText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }